import { render, staticRenderFns } from "./LiveDemo.vue?vue&type=template&id=39cf2698"
import script from "./LiveDemo.vue?vue&type=script&lang=ts"
export * from "./LiveDemo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports